msgid ""
msgstr ""
"POT-Creation-Date: 2026-07-22\n"
"Language: fr\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: Lingui\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: src/routes/Users.tsx:80
msgid " (you)"
msgstr " (vous)"

#: src/routes/Plans.tsx:331
msgid "— off —"
msgstr "— désactivé —"

#: src/routes/Plans.tsx:310
msgid "— same as the chat model —"
msgstr "— identique au modèle de chat —"

#: src/routes/Plans.tsx:296
msgid "— select —"
msgstr "— sélectionner —"

#: src/components/FeatureSelector.tsx:84
msgid ".write and .post still require the write-mode checkbox on the remote config"
msgstr ".write et .post nécessitent aussi la case mode écriture sur la config distante"

#. placeholder {0}: features.size
#. placeholder {1}: ALL_FEATURE_IDS.length
#: src/components/FeatureSelector.tsx:58
msgid "({0} of {1} active)"
msgstr "({0} sur {1} actives)"

#: src/routes/LicenseSwaps.tsx:92
#: src/routes/LicenseSwaps.tsx:106
msgid "(any)"
msgstr "(tous)"

#: src/routes/CustomerDetail.tsx:1215
#: src/routes/CustomerDetail.tsx:1295
msgid "(gate for every <0>.write</0> and <1>.post</1> feature — required in addition to the checkboxes above)"
msgstr "(barrière pour chaque fonctionnalité <0>.write</0> et <1>.post</1> — requise en plus des cases ci-dessus)"

#: src/routes/CustomerDetail.tsx:684
msgid "(no label)"
msgstr "(sans étiquette)"

#: src/routes/Monitoring.tsx:225
msgid "(no message)"
msgstr "(aucun message)"

#: src/routes/ConversationDetail.tsx:120
#: src/routes/Conversations.tsx:503
msgid "(untitled)"
msgstr "(sans titre)"

#. placeholder {0}: h.month
#. placeholder {1}: h.costUsd.toFixed(2)
#. placeholder {2}: h.turnCount
#: src/routes/CustomerDetail.tsx:1481
msgid "{0} — ${1} · {2} turns"
msgstr "{0} — {1} $ · {2} tours"

#. placeholder {0}: h.month
#. placeholder {1}: h.costUsd.toFixed(2)
#. placeholder {2}: credited.toFixed(2)
#. placeholder {3}: h.turnCount
#: src/routes/CustomerDetail.tsx:1480
msgid "{0} — ${1} billed · ${2} credited · {3} turns"
msgstr "{0} — {1} $ facturés · {2} $ crédités · {3} tours"

#. placeholder {0}: p.label
#: src/routes/LlmModels.tsx:464
msgid "{0} (archived)"
msgstr "{0} (archivé)"

#. placeholder {0}: rate(request.rates.inputPerMtok)
#: src/components/RequestPricing.tsx:19
msgid "{0} (input-rate fallback)"
msgstr "{0} (repli sur le tarif d’entrée)"

#. placeholder {0}: u.licenses.filter(l => l.exhausted).length
#. placeholder {1}: u.licenses.length
#: src/routes/Customers.tsx:71
msgid "{0} exhausted licences / {1}"
msgstr "{0} licences épuisées / {1}"

#. placeholder {0}: formatCost(costUsd, i18n.locale)
#: src/routes/ConversationDetail.tsx:367
msgid "{0} stops counting against the customer's plan budget and licence cap, and the conversation disappears from the customer's app. You can undo this later."
msgstr "{0} cessent de compter dans le budget du plan et le plafond de la licence, et la conversation disparaît de l'application du client. Vous pourrez annuler ce crédit plus tard."

#. placeholder {0}: failedTurns.length
#: src/routes/ConversationDetail.tsx:159
msgid "{0} turn(s) did not complete"
msgstr "{0} tour(s) n'ont pas abouti"

#. placeholder {0}: pctOfBudget.toFixed(0)
#: src/routes/Usage.tsx:333
msgid "{0}% of budget"
msgstr "{0} % du budget"

#. placeholder {0}: pctOfBudget.toFixed(0)
#. placeholder {1}: pctOfCap.toFixed(0)
#: src/routes/Usage.tsx:329
msgid "{0}% of budget · {1}% of hard cap"
msgstr "{0} % du budget · {1} % du plafond"

#. placeholder {0}: p.retentionDays
#: src/routes/Plans.tsx:100
msgid "{0}d"
msgstr "{0} j"

#. placeholder {0}: Math.floor(seconds / 86400)
#: src/routes/Monitoring.tsx:312
msgid "{0}d ago"
msgstr "il y a {0} j"

#. placeholder {0}: Math.floor(seconds / 3600)
#: src/routes/Monitoring.tsx:311
msgid "{0}h ago"
msgstr "il y a {0} h"

#. placeholder {0}: Math.floor(seconds / 60)
#: src/routes/Monitoring.tsx:310
msgid "{0}m ago"
msgstr "il y a {0} min"

#: src/routes/Conversations.tsx:214
msgid "{failedTurnCount} failed turn(s), without an error code"
msgstr "{failedTurnCount} tour(s) en échec, sans code d'erreur"

#. placeholder {0}: turnErrorCodes.join(", ")
#: src/routes/Conversations.tsx:213
msgid "{failedTurnCount} failed turn(s): {0}"
msgstr "{failedTurnCount} tour(s) en échec : {0}"

#: src/routes/Monitoring.tsx:309
msgid "{seconds}s ago"
msgstr "il y a {seconds} s"

#. placeholder {0}: toolNames.join(", ")
#: src/routes/Conversations.tsx:210
msgid "{toolFailureCount} failed call(s): {0}"
msgstr "{toolFailureCount} appel(s) en échec : {0}"

#. placeholder {0}: offset + 1
#. placeholder {1}: Math.min(offset + entries.length, total)
#: src/routes/AuditLog.tsx:94
#: src/routes/LicenseSwaps.tsx:122
msgid "{total} total entries — showing {0}–{1}"
msgstr "{total} entrées au total — affichage {0}–{1}"

#: src/routes/Customers.tsx:298
msgid "/mo"
msgstr "/mois"

#: src/routes/ConversationDetail.tsx:118
msgid "← All conversations"
msgstr "← Toutes les conversations"

#: src/routes/NewConfig.tsx:300
#: src/routes/SealSecrets.tsx:242
msgid "← Back to customer"
msgstr "← Retour au client"

#: src/routes/AuditLog.tsx:158
#: src/routes/LicenseSwaps.tsx:190
msgid "← Newer"
msgstr "← Plus récent"

#: src/routes/CustomerDetail.tsx:1453
msgid "12-month history"
msgstr "Historique sur 12 mois"

#: src/routes/ConversationDetail.tsx:344
msgid "A note is required when the reason is \"Other\"."
msgstr "Une note est obligatoire lorsque la raison est « Autre »."

#: src/routes/Releases.tsx:324
msgid "ab12…64 hex"
msgstr "ab12…64 caractères hex"

#: src/routes/NewConfig.tsx:360
msgid "Accounting — Montreal"
msgstr "Comptabilité — Montréal"

#: src/features-catalog.ts:40
msgid "Accounts Payable"
msgstr "Comptes fournisseurs"

#: src/features-catalog.ts:48
msgid "Accounts Receivable"
msgstr "Comptes clients"

#: src/routes/AuditLog.tsx:104
#: src/routes/LicenseSwaps.tsx:98
#: src/routes/LicenseSwaps.tsx:132
msgid "Action"
msgstr "Action"

#: src/routes/CustomerDetail.tsx:524
msgid "Activation"
msgstr "Activation"

#: src/routes/CustomerDetail.tsx:825
#: src/routes/Users.tsx:88
msgid "active"
msgstr "actif"

#: src/routes/Releases.tsx:180
msgid "Active releases"
msgstr "Versions actives"

#: src/routes/NewConfig.tsx:561
msgid "Add a company"
msgstr "Ajouter une société"

#: src/routes/LlmModels.tsx:130
msgid "Add price"
msgstr "Ajouter un prix"

#: src/routes/AuditLog.tsx:102
msgid "Admin"
msgstr "Admin"

#: src/routes/AuditLog.tsx:59
msgid "Admin audit log"
msgstr "Journal d'audit admin"

#: src/routes/SystemPrompts.tsx:120
#: src/routes/SystemPrompts.tsx:289
msgid "Admin label"
msgstr "Libellé d'administration"

#: src/routes/SystemPrompts.tsx:254
msgid "Admin label is required"
msgstr "Le libellé d'administration est requis"

#: src/features-catalog.ts:113
msgid "Administrative Services"
msgstr "Services administratifs"

#: src/routes/CustomerDetail.tsx:557
msgid "Administrator authorization required"
msgstr "Autorisation de l’administrateur requise"

#: src/routes/Users.tsx:59
msgid "Administrators & resellers"
msgstr "Administrateurs et revendeurs"

#: src/features-catalog.ts:33
msgid "Advanced Windows-isolated document scripts (approval required per run)"
msgstr "Scripts documentaires avancés isolés par Windows (approbation requise à chaque exécution)"

#: src/routes/Errors.tsx:469
#: src/routes/Monitoring.tsx:144
msgid "Agent"
msgstr "Agent"

#. placeholder {0}: m.agentVersion
#: src/routes/CustomerDetail.tsx:673
msgid "agent {0}"
msgstr "agent {0}"

#: src/routes/Monitoring.tsx:126
msgid "all"
msgstr "tous"

#: src/routes/Conversations.tsx:65
#: src/routes/Conversations.tsx:76
#: src/routes/Customers.tsx:237
msgid "All"
msgstr "Toutes"

#: src/routes/Conversations.tsx:311
#: src/routes/Errors.tsx:276
msgid "All customers"
msgstr "Tous les clients"

#: src/routes/Conversations.tsx:329
#: src/routes/Errors.tsx:294
msgid "All machines"
msgstr "Toutes les machines"

#: src/routes/LlmModels.tsx:161
#: src/routes/LlmModels.tsx:602
msgid "All rates are USD per million tokens. Empty cache rates use the input rate of the selected tier; zero means free."
msgstr "Tous les tarifs sont en USD par million de jetons. Un tarif de cache vide utilise le tarif d’entrée du palier sélectionné ; zéro signifie gratuit."

#: src/routes/Conversations.tsx:407
msgid "All reasons"
msgstr "Tous les motifs"

#: src/routes/CustomerDetail.tsx:1215
#: src/routes/CustomerDetail.tsx:1295
msgid "Allow write mode"
msgstr "Autoriser le mode écriture"

#: src/routes/CustomerDetail.tsx:1348
msgid "Allowances belong to each licence and cannot be shared."
msgstr "Les allocations appartiennent à chaque licence et ne peuvent pas être partagées."

#: src/routes/SealSecrets.tsx:298
msgid "already sealed"
msgstr "déjà scellée"

#: src/routes/CustomerDetail.tsx:1398
msgid "Amount"
msgstr "Montant"

#: src/routes/NewConfig.tsx:516
msgid "API version"
msgstr "Version d'API"

#: src/components/RequestPricing.tsx:30
msgid "Applied tier"
msgstr "Palier appliqué"

#: src/routes/CustomerDetail.tsx:1106
msgid "Applies at the next agent config poll — the mcp-server restarts with the new schema bundle."
msgstr "S'applique au prochain sondage de configuration de l'agent — le mcp-server redémarre avec le nouveau bundle de schéma."

#: src/routes/NewConfig.tsx:337
msgid "Applies to conversation source files and generated documents on each customer machine."
msgstr "S’applique aux fichiers sources des conversations et aux documents générés sur chaque machine cliente."

#: src/routes/LlmModels.tsx:610
msgid "Applies to the whole request only when total input, including cache reads and writes, strictly exceeds the threshold."
msgstr "S’applique à toute la requête uniquement lorsque le total des jetons d’entrée, lectures et écritures de cache comprises, dépasse strictement le seuil."

#. placeholder {0}: e.status
#: src/routes/Monitoring.tsx:213
msgid "apply {0}"
msgstr "application {0}"

#: src/routes/Monitoring.tsx:95
msgid "Apply failed (24h)"
msgstr "Applications échouées (24 h)"

#: src/routes/Monitoring.tsx:90
msgid "Apply ok (24h)"
msgstr "Applications réussies (24 h)"

#: src/routes/LicenseSwaps.tsx:93
msgid "approved"
msgstr "approuvé"

#: src/routes/Releases.tsx:130
#: src/routes/SystemPrompts.tsx:99
msgid "Archive"
msgstr "Archiver"

#. placeholder {0}: p.label
#: src/routes/SystemPrompts.tsx:45
msgid "Archive prompt \"{0}\"? Any active model still using it must be reassigned first."
msgstr "Archiver le prompt « {0} » ? Tout modèle actif qui l'utilise encore doit d'abord être réassigné."

#. placeholder {0}: v.version
#. placeholder {1}: v.channel
#: src/routes/Releases.tsx:54
msgid "Archive version {0} on {1}? Agents will stop seeing it as the latest release."
msgstr "Archiver la version {0} sur le canal {1} ? Les agents ne la verront plus comme la dernière version disponible."

#: src/routes/ConversationDetail.tsx:131
#: src/routes/Conversations.tsx:505
msgid "archived"
msgstr "archivée"

#: src/routes/Conversations.tsx:420
msgid "Archived"
msgstr "Archivées"

#: src/routes/SystemPrompts.tsx:165
msgid "Archived prompts"
msgstr "Prompts archivés"

#: src/routes/Releases.tsx:186
msgid "Archived releases"
msgstr "Versions archivées"

#: src/components/Layout.tsx:185
msgid "Audit log"
msgstr "Journal d'audit"

#: src/routes/CustomerDetail.tsx:629
#: src/routes/Usage.tsx:144
msgid "Available"
msgstr "Disponible"

#: src/routes/CustomerDetail.tsx:557
msgid "Awaiting activation"
msgstr "En attente d’activation"

#: src/routes/CustomerDetail.tsx:557
msgid "Awaiting replacement"
msgstr "En attente du remplacement"

#: src/routes/ConversationDetail.tsx:90
msgid "Back to list"
msgstr "Retour à la liste"

#: src/features-catalog.ts:92
msgid "Bank Services"
msgstr "Services bancaires"

#: src/routes/NewConfig.tsx:487
msgid "Base URL"
msgstr "URL de base"

#: src/routes/CustomerDetail.tsx:1460
msgid "Billed"
msgstr "Facturé"

#: src/components/Layout.tsx:168
msgid "Billing"
msgstr "Facturation"

#: src/routes/Usage.tsx:110
msgid "Budget"
msgstr "Budget"

#: src/routes/Plans.tsx:140
msgid "Budget / month"
msgstr "Budget / mois"

#: src/routes/CustomerDetail.tsx:1352
#~ msgid "By licence"
#~ msgstr "Par licence"

#: src/routes/CustomerDetail.tsx:1406
#~ msgid "By model"
#~ msgstr "Par modèle"

#: src/components/RequestPricing.tsx:43
#: src/routes/ConversationDetail.tsx:261
#: src/routes/ConversationDetail.tsx:440
msgid "Cache write"
msgstr "Écriture cache"

#: src/routes/LlmModels.tsx:578
msgid "Cache write $/1M tokens (optional — set for models with a cache-write premium; leave empty to bill at the input rate)"
msgstr "Écriture cache $/1M jetons (optionnel — à renseigner pour les modèles avec surcoût d'écriture cache ; laisser vide pour facturer au tarif d'entrée)"

#: src/routes/LlmModels.tsx:627
msgid "Cache write $/1M tokens (optional)"
msgstr "Écriture de cache $/1M jetons (facultatif)"

#: src/routes/LlmModels.tsx:169
msgid "Cache write $/Mtok"
msgstr "Écriture cache $/Mjet"

#: src/routes/ConversationDetail.tsx:441
msgid "cache-w"
msgstr "cache-écr"

#: src/routes/Conversations.tsx:483
msgid "Cache-w"
msgstr "Cache-écr"

#: src/routes/ConversationDetail.tsx:436
msgid "cached"
msgstr "en cache"

#: src/routes/Conversations.tsx:482
msgid "Cached"
msgstr "En cache"

#: src/routes/LlmModels.tsx:566
#: src/routes/LlmModels.tsx:622
msgid "Cached input $/1M tokens (optional)"
msgstr "Entrée cachée $/1M jetons (optionnel)"

#: src/routes/LlmModels.tsx:168
msgid "Cached input $/Mtok"
msgstr "Entrée cachée $/Mjet"

#: src/components/RequestPricing.tsx:42
#: src/routes/ConversationDetail.tsx:255
#: src/routes/ConversationDetail.tsx:435
msgid "Cached read"
msgstr "Lecture cache"

#: src/routes/Usage.tsx:227
msgid "Calls"
msgstr "Appels"

#: src/features-catalog.ts:106
msgid "Canadian Payroll"
msgstr "Paie canadienne"

#: src/components/ChangeLicensePlanDialog.tsx:79
#: src/components/TransferLicenseDialog.tsx:45
#: src/routes/ConversationDetail.tsx:400
#: src/routes/CustomerDetail.tsx:1060
#: src/routes/CustomerDetail.tsx:1129
#: src/routes/CustomerDetail.tsx:1221
#: src/routes/CustomerDetail.tsx:1301
#: src/routes/Customers.tsx:409
#: src/routes/LlmModels.tsx:476
#: src/routes/LlmModels.tsx:641
#: src/routes/NewConfig.tsx:585
#: src/routes/Plans.tsx:399
#: src/routes/Releases.tsx:353
#: src/routes/SystemPrompts.tsx:376
#: src/routes/Users.tsx:208
msgid "Cancel"
msgstr "Annuler"

#: src/features-catalog.ts:140
msgid "Cdn PR Tax Update"
msgstr "Mise à jour impôts paie canadienne"

#: src/components/ChangeLicensePlanDialog.tsx:50
#: src/routes/CustomerDetail.tsx:549
msgid "Change licence plan"
msgstr "Changer le forfait de la licence"

#: src/routes/CustomerDetail.tsx:431
#: src/routes/CustomerDetail.tsx:1104
msgid "Change Sage version"
msgstr "Changer la version de Sage"

#: src/routes/Releases.tsx:145
#: src/routes/Releases.tsx:298
msgid "Channel"
msgstr "Canal"

#: src/routes/Conversations.tsx:69
msgid "Clean"
msgstr "Sans échec"

#: src/components/FeatureSelector.tsx:100
msgid "Clear"
msgstr "Effacer"

#: src/routes/Conversations.tsx:248
#: src/routes/Errors.tsx:172
msgid "Clear all filters"
msgstr "Effacer tous les filtres"

#: src/routes/Conversations.tsx:465
#: src/routes/Errors.tsx:373
msgid "Clear filters"
msgstr "Effacer les filtres"

#: src/routes/Conversations.tsx:275
#: src/routes/Errors.tsx:199
msgid "Clear search"
msgstr "Effacer la recherche"

#: src/components/Layout.tsx:163
msgid "Clients"
msgstr "Clients"

#: src/routes/CustomerDetail.tsx:852
#: src/routes/CustomerDetail.tsx:976
msgid "Close"
msgstr "Fermer"

#: src/routes/Errors.tsx:457
#: src/routes/Plans.tsx:137
#: src/routes/Plans.tsx:280
msgid "Code"
msgstr "Code"

#: src/routes/ConversationDetail.tsx:555
msgid "Collapse"
msgstr "Réduire"

#: src/credit-reason-labels.ts:18
msgid "Commercial gesture"
msgstr "Geste commercial"

#: src/features-catalog.ts:99
msgid "Common Services"
msgstr "Services communs"

#: src/routes/SealSecrets.tsx:266
msgid "Companies this machine may query"
msgstr "Sociétés que cette machine peut interroger"

#: src/routes/CustomerDetail.tsx:789
#: src/routes/Customers.tsx:399
msgid "Company"
msgstr "Entreprise"

#: src/routes/NewConfig.tsx:509
msgid "Company (Sage code)"
msgstr "Société (code Sage)"

#: src/routes/NewConfig.tsx:370
msgid "Company id (local slug)"
msgstr "ID de société (slug local)"

#: src/routes/NewConfig.tsx:389
msgid "Company id (local slug):"
msgstr "Id de société (slug local) :"

#: src/routes/CustomerDetail.tsx:661
#: src/routes/Monitoring.tsx:147
msgid "Config"
msgstr "Config"

#: src/routes/CustomerDetail.tsx:660
msgid "Configurations"
msgstr "Configurations"

#: src/components/ChangeLicensePlanDialog.tsx:80
msgid "Confirm plan change"
msgstr "Confirmer le changement de forfait"

#: src/components/TransferLicenseDialog.tsx:47
msgid "Confirm transfer"
msgstr "Confirmer le transfert"

#: src/routes/Customers.tsx:260
msgid "Contact"
msgstr "Contact"

#: src/routes/Customers.tsx:386
msgid "Contact email"
msgstr "Courriel du contact"

#: src/routes/Customers.tsx:395
msgid "Contact name"
msgstr "Nom du contact"

#: src/routes/SystemPrompts.tsx:299
msgid "Content"
msgstr "Contenu"

#: src/routes/SystemPrompts.tsx:258
msgid "Content is required"
msgstr "Le contenu est requis"

#: src/routes/Errors.tsx:482
#: src/routes/LlmModels.tsx:207
msgid "Context"
msgstr "Contexte"

#: src/routes/LlmModels.tsx:413
msgid "Context window (tokens)"
msgstr "Fenêtre de contexte (jetons)"

#: src/routes/ConversationDetail.tsx:77
#: src/routes/ConversationDetail.tsx:88
#: src/routes/CustomerDetail.tsx:1394
msgid "Conversation"
msgstr "Conversation"

#: src/routes/Conversations.tsx:443
msgid "conversation(s)"
msgstr "conversation(s)"

#: src/components/Layout.tsx:182
#: src/routes/Conversations.tsx:242
msgid "Conversations"
msgstr "Conversations"

#: src/routes/NewConfig.tsx:550
msgid "Conversations that use this company become read-only. The row stays in the config so it can be reactivated later; sealed passwords are kept."
msgstr "Les conversations qui utilisent cette société deviendront consultables mais ne pourront plus être poursuivies. La ligne reste dans la config pour pouvoir la réactiver plus tard ; les mots de passe scellés sont conservés."

#: src/components/CopyButton.tsx:77
msgid "Copied"
msgstr "Copié"

#: src/components/CopyButton.tsx:72
msgid "Copy"
msgstr "Copier"

#: src/routes/CustomerDetail.tsx:542
#: src/routes/CustomerDetail.tsx:851
msgid "Copy licence key"
msgstr "Copier la clé de licence"

#: src/routes/Conversations.tsx:485
#: src/routes/CustomerDetail.tsx:527
#: src/routes/Usage.tsx:230
msgid "Cost"
msgstr "Coût"

#: src/routes/Customers.tsx:265
msgid "Cost (mo)"
msgstr "Coût (mois)"

#: src/routes/SystemPrompts.tsx:333
msgid "Cost per call"
msgstr "Coût par appel"

#: src/auth.tsx:264
msgid "Could not reach the cloud API. Check VITE_CLOUD_API_URL or that the service is running."
msgstr "Impossible de joindre l'API cloud. Vérifiez VITE_CLOUD_API_URL ou que le service fonctionne."

#: src/routes/Customers.tsx:412
#: src/routes/Users.tsx:211
msgid "Create"
msgstr "Créer"

#: src/routes/ConversationDetail.tsx:187
#: src/routes/CustomerDetail.tsx:1543
#: src/routes/Customers.tsx:272
msgid "Created"
msgstr "Créé le"

#: src/routes/CustomerDetail.tsx:1224
#: src/routes/Customers.tsx:412
#: src/routes/Users.tsx:211
msgid "Creating…"
msgstr "Création…"

#: src/routes/ConversationDetail.tsx:140
#: src/routes/ConversationDetail.tsx:403
msgid "Credit"
msgstr "Créditer"

#: src/routes/ConversationDetail.tsx:365
msgid "Credit this conversation"
msgstr "Créditer cette conversation"

#: src/routes/ConversationDetail.tsx:132
msgid "credited"
msgstr "créditée"

#: src/routes/CustomerDetail.tsx:631
#: src/routes/CustomerDetail.tsx:1397
#: src/routes/CustomerDetail.tsx:1464
msgid "Credited"
msgstr "Crédité"

#: src/routes/Customers.tsx:269
msgid "Credited (mo)"
msgstr "Crédité (mois)"

#: src/routes/CustomerDetail.tsx:1396
msgid "Credited by"
msgstr "Crédité par"

#. placeholder {0}: detail.credit.creditedByEmail ?? "—"
#. placeholder {1}: new Date(detail.credit.createdAt).toLocaleString(i18n.locale)
#. placeholder {2}: i18n._(CREDIT_REASON_LABELS[detail.credit.reason])
#: src/routes/ConversationDetail.tsx:202
msgid "Credited by {0} on {1} — {2}"
msgstr "Créditée par {0} le {1} — {2}"

#: src/routes/CustomerDetail.tsx:1384
msgid "Credited conversations"
msgstr "Conversations créditées"

#: src/routes/CustomerDetail.tsx:1373
msgid "Credited this month"
msgstr "Crédité ce mois"

#: src/routes/ConversationDetail.tsx:403
msgid "Crediting…"
msgstr "Crédit en cours…"

#: src/features-catalog.ts:29
msgid "Cross-module SQL joins (sage300_db_cross_query)"
msgstr "Jointures SQL inter-modules (sage300_db_cross_query)"

#: src/routes/CustomerDetail.tsx:525
msgid "Current machine"
msgstr "Machine actuelle"

#: src/components/ChangeLicensePlanDialog.tsx:65
msgid "Current retention: {currentDays} days."
msgstr "Conservation actuelle : {currentDays} jours."

#: src/routes/ConversationDetail.tsx:178
#: src/routes/Conversations.tsx:300
#: src/routes/Conversations.tsx:476
#: src/routes/Errors.tsx:265
#: src/routes/Errors.tsx:386
#: src/routes/LicenseSwaps.tsx:130
#: src/routes/Monitoring.tsx:141
#: src/routes/Monitoring.tsx:202
#: src/routes/Usage.tsx:99
msgid "Customer"
msgstr "Client"

#: src/routes/CustomerDetail.tsx:477
msgid "Customer deactivated"
msgstr "Client désactivé"

#: src/routes/LicenseSwaps.tsx:62
msgid "Customer ID"
msgstr "ID client"

#: src/routes/CustomerDetail.tsx:386
msgid "Customer not found."
msgstr "Client introuvable."

#: src/routes/Errors.tsx:322
msgid "Customer: {selectedCustomerName}"
msgstr "Client : {selectedCustomerName}"

#: src/routes/Customers.tsx:294
msgid "customers"
msgstr "clients"

#: src/components/Layout.tsx:164
#: src/routes/Customers.tsx:228
msgid "Customers"
msgstr "Clients"

#: src/feedback-labels.ts:16
msgid "Data does not match Sage"
msgstr "Les données ne correspondent pas à Sage"

#: src/routes/NewConfig.tsx:438
msgid "Database"
msgstr "Base de données"

#: src/routes/NewConfig.tsx:445
msgid "DB user"
msgstr "Utilisateur BD"

#: src/routes/LlmModels.tsx:137
#: src/routes/Plans.tsx:116
msgid "Deactivate"
msgstr "Désactiver"

#. placeholder {0}: customer.name
#: src/routes/CustomerDetail.tsx:317
msgid "Deactivate {0}? Every licence attached to this customer will stop working at the next agent request. You can add a short note (optional):"
msgstr "Désactiver {0} ? Toutes les licences rattachées à ce client cesseront de fonctionner à la prochaine requête d'agent. Vous pouvez ajouter une note courte (facultatif) :"

#: src/routes/CustomerDetail.tsx:450
msgid "Deactivate customer"
msgstr "Désactiver le client"

#. placeholder {0}: m.displayName
#: src/routes/LlmModels.tsx:65
msgid "Deactivate model \"{0}\"? Active plans referencing it must be reassigned first."
msgstr "Désactiver le modèle « {0} » ? Les forfaits actifs qui le référencent doivent être réassignés d'abord."

#. placeholder {0}: p.code
#: src/routes/Plans.tsx:43
msgid "Deactivate plan \"{0}\"? Customers attached to it must be reassigned first."
msgstr "Désactiver le forfait « {0} » ? Les clients qui y sont rattachés doivent être réassignés d'abord."

#: src/routes/NewConfig.tsx:552
msgid "Deactivate this company"
msgstr "Désactiver cette société"

#: src/routes/Customers.tsx:30
msgid "deactivated"
msgstr "désactivé"

#: src/routes/CustomerDetail.tsx:809
msgid "default"
msgstr "par défaut"

#: src/routes/NewConfig.tsx:426
msgid "Default company for this customer"
msgstr "Société par défaut pour ce client"

#: src/routes/CustomerDetail.tsx:613
#: src/routes/CustomerDetail.tsx:738
msgid "Delete"
msgstr "Supprimer"

#. placeholder {0}: l.licenseKey
#: src/routes/CustomerDetail.tsx:281
msgid "Delete licence {0}? This cannot be undone. Any machine still bound to it must be deleted first."
msgstr "Supprimer la licence {0} ? Cette action est irréversible. Toute machine encore liée doit être supprimée en premier."

#: src/routes/CustomerDetail.tsx:299
msgid "Delete this machine? This wipes its heartbeats, config state and encrypted secrets. This cannot be undone."
msgstr "Supprimer cette machine ? Efface ses battements, son état de config et ses secrets chiffrés. Irréversible."

#: src/routes/CustomerDetail.tsx:849
msgid "Deliver this rotated key securely to the replacement operator. Use Change license key on the desktop to validate and protect the key, then configure Sage access. Old-machine files remain on the old machine."
msgstr "Transmettez cette nouvelle clé de manière sécurisée à l’opérateur du remplacement. Utilisez Changer la clé de licence dans l’application pour valider et protéger la clé, puis configurez l’accès Sage. Les fichiers de l’ancienne machine y restent."

#: src/credit-reason-labels.ts:17
msgid "Demo"
msgstr "Démonstration"

#: src/routes/Monitoring.tsx:204
msgid "Detail"
msgstr "Détail"

#: src/routes/AuditLog.tsx:128
msgid "Diff"
msgstr "Diff"

#: src/routes/Customers.tsx:53
msgid "Direct"
msgstr "Direct"

#: src/routes/CustomerDetail.tsx:419
#: src/routes/Customers.tsx:238
msgid "Direct (Jalfa)"
msgstr "Direct (Jalfa)"

#: src/routes/Users.tsx:102
msgid "Disable"
msgstr "Désactiver"

#: src/routes/CustomerDetail.tsx:823
#: src/routes/SealSecrets.tsx:295
#: src/routes/Users.tsx:88
msgid "disabled"
msgstr "désactivé"

#: src/routes/NewConfig.tsx:350
msgid "Disabled"
msgstr "Désactivée"

#: src/routes/NewConfig.tsx:535
msgid "Discard this new company"
msgstr "Abandonner cette nouvelle société"

#: src/features-catalog.ts:25
msgid "Discovery tools (search_entities, describe_entity, resolve_question)"
msgstr "Outils de découverte (search_entities, describe_entity, resolve_question)"

#: src/routes/LlmModels.tsx:206
#: src/routes/LlmModels.tsx:405
#: src/routes/NewConfig.tsx:356
msgid "Display name"
msgstr "Nom affiché"

#: src/routes/NewConfig.tsx:323
msgid "Document storage"
msgstr "Stockage des documents"

#: src/routes/SealSecrets.tsx:344
msgid "Done"
msgstr "Terminé"

#: src/routes/Releases.tsx:151
#: src/routes/Releases.tsx:310
msgid "Download URL"
msgstr "URL de téléchargement"

#: src/credit-reason-labels.ts:19
msgid "Duplicate turn"
msgstr "Tour en double"

#: src/routes/CustomerDetail.tsx:1205
#: src/routes/CustomerDetail.tsx:1285
msgid "e.g. HQ production, staging, trial 2026-Q1"
msgstr "ex. production HQ, staging, essai 2026-T1"

#: src/routes/CustomerDetail.tsx:580
#: src/routes/CustomerDetail.tsx:589
#: src/routes/CustomerDetail.tsx:768
#: src/routes/LlmModels.tsx:117
#: src/routes/LlmModels.tsx:125
#: src/routes/NewConfig.tsx:395
#: src/routes/Plans.tsx:103
#: src/routes/Plans.tsx:108
#: src/routes/Releases.tsx:109
#: src/routes/Releases.tsx:114
#: src/routes/SystemPrompts.tsx:86
#: src/routes/SystemPrompts.tsx:91
msgid "Edit"
msgstr "Modifier"

#. placeholder {0}: model!.displayName
#. placeholder {0}: prompt!.label
#: src/routes/LlmModels.tsx:381
#: src/routes/SystemPrompts.tsx:286
msgid "Edit {0}"
msgstr "Modifier {0}"

#: src/routes/CustomerDetail.tsx:1272
msgid "Edit licence"
msgstr "Modifier la licence"

#: src/routes/Plans.tsx:277
msgid "Edit plan"
msgstr "Modifier le forfait"

#: src/routes/Releases.tsx:278
msgid "Edit release"
msgstr "Modifier la version"

#: src/routes/NewConfig.tsx:307
msgid "Editing the live config (revision {prefilledFrom}). Saving fans the change out to every connected machine of this customer; sealed passwords stay put."
msgstr "Modification de la config active (révision {prefilledFrom}). L'enregistrement propage le changement à toutes les machines connectées de ce client ; les mots de passe scellés restent en place."

#: src/routes/LlmModels.tsx:165
msgid "Effective at"
msgstr "Effectif le"

#: src/routes/LlmModels.tsx:547
msgid "Effective at (ISO 8601)"
msgstr "Effectif le (ISO 8601)"

#: src/routes/Login.tsx:21
#: src/routes/Users.tsx:69
#: src/routes/Users.tsx:178
msgid "Email"
msgstr "Courriel"

#: src/auth.tsx:251
msgid "Email and password are required"
msgstr "Le courriel et le mot de passe sont requis"

#: src/components/Layout.tsx:243
msgid "emergency root"
msgstr "root d'urgence"

#: src/routes/LlmModels.tsx:605
msgid "Enable long-context pricing"
msgstr "Activer la tarification pour les contextes longs"

#: src/routes/NewConfig.tsx:469
msgid "Encrypt TLS (recommended — keep on)"
msgstr "Chiffrer TLS (recommandé — garder activé)"

#. placeholder {0}: incomplete.map(companyDisplayName).join(", ")
#: src/routes/SealSecrets.tsx:158
msgid "Enter a password for: {0}"
msgstr "Saisissez un mot de passe pour : {0}"

#: src/routes/AuditLog.tsx:62
#: src/routes/AuditLog.tsx:103
msgid "Entity"
msgstr "Entité"

#: src/routes/AuditLog.tsx:73
msgid "Entity ID"
msgstr "ID d'entité"

#: src/routes/Monitoring.tsx:297
msgid "error"
msgstr "erreur"

#: src/routes/Errors.tsx:313
msgid "error(s)"
msgstr "erreur(s)"

#: src/components/Layout.tsx:184
#: src/routes/Errors.tsx:166
msgid "Errors"
msgstr "Erreurs"

#: src/routes/Monitoring.tsx:100
msgid "Errors (24h)"
msgstr "Erreurs (24 h)"

#: src/routes/CustomerDetail.tsx:1542
msgid "Estimated cost"
msgstr "Coût estimé"

#: src/routes/SystemPrompts.tsx:310
msgid "Estimated cost per model"
msgstr "Coût estimé par modèle"

#: src/routes/SystemPrompts.tsx:367
msgid "Estimating…"
msgstr "Estimation…"

#: src/routes/CustomerDetail.tsx:499
msgid "Every licence attached to this customer is refused at the cloud auth layer. Individual licence/machine statuses are unchanged."
msgstr "Toutes les licences rattachées à ce client sont refusées au niveau de l'authentification cloud. Les statuts individuels des licences et des machines restent inchangés."

#: src/components/FeatureSelector.tsx:93
msgid "Everything"
msgstr "Tout"

#: src/routes/CustomerDetail.tsx:629
#: src/routes/Usage.tsx:144
msgid "Exhausted"
msgstr "Épuisée"

#: src/routes/ConversationDetail.tsx:555
msgid "Expand"
msgstr "Développer"

#: src/components/ChangeLicensePlanDialog.tsx:76
msgid "Extending retention cannot restore history that has already been deleted."
msgstr "Prolonger la conservation ne permet pas de restaurer l'historique déjà supprimé."

#: src/routes/LlmModels.tsx:440
msgid "Extra high"
msgstr "Très élevé"

#: src/routes/Monitoring.tsx:176
msgid "failed"
msgstr "échec"

#: src/routes/Users.tsx:50
msgid "Failed: {msg}"
msgstr "Échec : {msg}"

#: src/routes/Conversations.tsx:339
msgid "Failures"
msgstr "Échecs"

#: src/components/FeatureSelector.tsx:58
#: src/routes/CustomerDetail.tsx:528
msgid "Features"
msgstr "Fonctionnalités"

#. placeholder {0}: features.length
#: src/routes/CustomerDetail.tsx:950
msgid "Features ({0} active)"
msgstr "Fonctionnalités ({0} actives)"

#: src/routes/NewConfig.tsx:573
msgid "Features and write mode are set on the licence, not on the remote config. Edit the licence from the customer page to change what the MCP is allowed to touch on this customer's machines."
msgstr "Les fonctionnalités et le mode écriture sont définis sur la licence, pas sur la config distante. Modifiez la licence depuis la page client pour changer ce que le MCP peut toucher sur les machines de ce client."

#: src/routes/Conversations.tsx:478
msgid "Feedback"
msgstr "Retour"

#: src/routes/Conversations.tsx:77
msgid "Flagged"
msgstr "Signalées"

#: src/routes/LicenseSwaps.tsx:134
msgid "From → To"
msgstr "De → Vers"

#: src/routes/SystemPrompts.tsx:304
msgid "Full system prompt text — no length limit."
msgstr "Texte complet du prompt système — aucune limite de longueur."

#: src/features-catalog.ts:118
msgid "G/L Subledger Services"
msgstr "Services de sous-registre G/L"

#: src/features-catalog.ts:56
msgid "General Ledger"
msgstr "Grand livre"

#: src/routes/ConversationDetail.tsx:150
msgid "Guidance diagnostics"
msgstr "Diagnostic des procédures"

#: src/routes/Plans.tsx:350
msgid "Guidance mode"
msgstr "Mode des procédures"

#: src/routes/CustomerDetail.tsx:626
msgid "Hard cap slack"
msgstr "Marge du plafond strict"

#: src/routes/Monitoring.tsx:213
msgid "heartbeat"
msgstr "battement"

#: src/routes/Usage.tsx:109
msgid "Held"
msgstr "Retenu"

#: src/routes/CustomerDetail.tsx:628
#: src/routes/CustomerDetail.tsx:1364
#: src/routes/Usage.tsx:81
msgid "Held reservations"
msgstr "Réservations retenues"

#: src/routes/CustomerDetail.tsx:1536
msgid "Held reservations (in flight)"
msgstr "Réservations retenues (en cours)"

#: src/routes/ConversationDetail.tsx:475
msgid "helpful"
msgstr "utile"

#: src/routes/LlmModels.tsx:122
msgid "Hide"
msgstr "Masquer"

#: src/routes/AuditLog.tsx:128
msgid "Hide diff"
msgstr "Masquer le diff"

#: src/routes/LlmModels.tsx:439
msgid "High"
msgstr "Élevé"

#: src/components/TransferLicenseDialog.tsx:41
msgid "I authorize this replacement and revocation of the previous machine."
msgstr "J’autorise ce remplacement et la révocation de l’ancienne machine."

#: src/components/ChangeLicensePlanDialog.tsx:72
msgid "I understand and confirm the shorter retention window."
msgstr "Je comprends et confirme la réduction de la durée de conservation."

#: src/routes/CustomerDetail.tsx:790
msgid "Id"
msgstr "Id"

#: src/routes/AuditLog.tsx:105
msgid "ID"
msgstr "ID"

#: src/routes/ConversationDetail.tsx:432
msgid "in"
msgstr "in"

#: src/routes/LlmModels.tsx:231
msgid "Inactive models"
msgstr "Modèles inactifs"

#: src/routes/Plans.tsx:164
msgid "Inactive plans"
msgstr "Forfaits inactifs"

#: src/routes/Conversations.tsx:429
msgid "Include archived"
msgstr "Inclure les archivées"

#: src/feedback-labels.ts:15
msgid "Incomplete answer"
msgstr "Réponse incomplète"

#: src/routes/Conversations.tsx:481
#: src/routes/Usage.tsx:228
msgid "Input"
msgstr "Entrée"

#: src/routes/LlmModels.tsx:555
#: src/routes/LlmModels.tsx:617
msgid "Input $/1M tokens"
msgstr "Entrée $/1M jetons"

#: src/routes/LlmModels.tsx:167
#: src/routes/SystemPrompts.tsx:330
msgid "Input $/Mtok"
msgstr "Entrée $/Mjet"

#: src/components/RequestPricing.tsx:32
msgid "Input threshold"
msgstr "Seuil de jetons en entrée"

#: src/routes/LlmModels.tsx:612
msgid "Input token threshold"
msgstr "Seuil de jetons d’entrée"

#: src/components/RequestPricing.tsx:41
#: src/routes/ConversationDetail.tsx:249
#: src/routes/ConversationDetail.tsx:431
#: src/routes/CustomerDetail.tsx:633
#: src/routes/CustomerDetail.tsx:1352
#: src/routes/Usage.tsx:85
msgid "Input tokens"
msgstr "Jetons d'entrée"

#: src/routes/SystemPrompts.tsx:295
msgid "Internal name — used to pick this prompt from the models editor."
msgstr "Nom interne — utilisé pour sélectionner ce prompt depuis l'éditeur de modèles."

#: src/credit-reason-labels.ts:16
msgid "Internal testing"
msgstr "Test interne"

#: src/auth.tsx:261
msgid "Invalid email or password."
msgstr "Courriel ou mot de passe invalide."

#: src/features-catalog.ts:79
msgid "Inventory Control"
msgstr "Contrôle des stocks"

#: src/components/FeatureSelector.tsx:141
msgid "Irreversible postings (batches, adjustments)"
msgstr "Reports irréversibles (lots, ajustements)"

#: src/routes/CustomerDetail.tsx:1224
msgid "Issue"
msgstr "Émettre"

#: src/routes/CustomerDetail.tsx:512
#: src/routes/CustomerDetail.tsx:1184
msgid "Issue licence"
msgstr "Émettre une licence"

#: src/routes/CustomerDetail.tsx:521
msgid "Key"
msgstr "Clé"

#. placeholder {0}: license.licenseKey
#. placeholder {1}: license.planCode
#: src/routes/CustomerDetail.tsx:1274
msgid "Key <0>{0}</0> — a transfer rotates this key. This licence's plan is <1>{1}</1>."
msgstr "Clé <0>{0}</0> — un transfert renouvelle cette clé. Le forfait de cette licence est <1>{1}</1>."

#: src/routes/CustomerDetail.tsx:520
#: src/routes/CustomerDetail.tsx:1281
msgid "Label"
msgstr "Étiquette"

#: src/routes/CustomerDetail.tsx:1201
msgid "Label (optional)"
msgstr "Étiquette (optionnelle)"

#: src/routes/Conversations.tsx:444
#: src/routes/Errors.tsx:313
msgid "last {currentTimeLabel}"
msgstr "dernières {currentTimeLabel}"

#: src/routes/Monitoring.tsx:148
msgid "Last error"
msgstr "Dernière erreur"

#: src/routes/CustomerDetail.tsx:662
#: src/routes/Monitoring.tsx:149
msgid "Last heartbeat"
msgstr "Dernier battement"

#: src/routes/Users.tsx:72
msgid "Last sign-in"
msgstr "Dernière connexion"

#: src/routes/Errors.tsx:224
#: src/routes/Errors.tsx:384
msgid "Level"
msgstr "Niveau"

#: src/routes/Usage.tsx:102
msgid "Licence"
msgstr "Licence"

#: src/routes/CustomerDetail.tsx:581
msgid "Licence actions"
msgstr "Actions de la licence"

#: src/routes/CustomerDetail.tsx:424
#: src/routes/Customers.tsx:262
msgid "Licence plans"
msgstr "Forfaits des licences"

#: src/routes/CustomerDetail.tsx:511
msgid "Licences"
msgstr "Licences"

#: src/routes/LicenseSwaps.tsx:73
msgid "License ID (target)"
msgstr "ID de licence (cible)"

#: src/components/Layout.tsx:186
#: src/routes/LicenseSwaps.tsx:59
msgid "License swaps"
msgstr "Changements de licence"

#: src/routes/Conversations.tsx:542
#: src/routes/Errors.tsx:437
msgid "Load more"
msgstr "Charger plus"

#: src/routes/LlmModels.tsx:156
msgid "Loading prices…"
msgstr "Chargement des prix…"

#: src/routes/LlmModels.tsx:452
msgid "Loading system prompts…"
msgstr "Chargement des prompts système…"

#: src/routes/AuditLog.tsx:90
#: src/routes/ConversationDetail.tsx:79
#: src/routes/Conversations.tsx:438
#: src/routes/Conversations.tsx:459
#: src/routes/Conversations.tsx:542
#: src/routes/CustomerDetail.tsx:384
#: src/routes/CustomerDetail.tsx:1045
#: src/routes/Customers.tsx:252
#: src/routes/Errors.tsx:308
#: src/routes/Errors.tsx:364
#: src/routes/Errors.tsx:437
#: src/routes/LicenseSwaps.tsx:118
#: src/routes/LlmModels.tsx:225
#: src/routes/Monitoring.tsx:133
#: src/routes/NewConfig.tsx:292
#: src/routes/Plans.tsx:158
#: src/routes/Releases.tsx:175
#: src/routes/SealSecrets.tsx:234
#: src/routes/SystemPrompts.tsx:151
#: src/routes/Usage.tsx:75
#: src/routes/Users.tsx:64
msgid "Loading…"
msgstr "Chargement…"

#: src/routes/NewConfig.tsx:325
msgid "Local storage quota (MiB)"
msgstr "Quota de stockage local (Mio)"

#: src/components/RequestPricing.tsx:31
msgid "Long context"
msgstr "Contexte long"

#. placeholder {0}: p.longContext.inputTokenThreshold.toLocaleString(i18n.locale)
#: src/routes/LlmModels.tsx:184
msgid "Long context: input > {0} tokens"
msgstr "Contexte long : entrée > {0} jetons"

#: src/routes/LlmModels.tsx:609
msgid "Long-context tier"
msgstr "Palier de contexte long"

#: src/routes/LlmModels.tsx:437
msgid "Low"
msgstr "Faible"

#: src/routes/ConversationDetail.tsx:182
#: src/routes/Conversations.tsx:321
#: src/routes/Conversations.tsx:477
#: src/routes/Errors.tsx:286
#: src/routes/Errors.tsx:385
#: src/routes/Monitoring.tsx:142
#: src/routes/Monitoring.tsx:203
msgid "Machine"
msgstr "Machine"

#: src/routes/CustomerDetail.tsx:709
msgid "Machine actions"
msgstr "Actions de la machine"

#: src/routes/SealSecrets.tsx:252
msgid "Machine public key fingerprint"
msgstr "Empreinte de la clé publique de la machine"

#: src/routes/Errors.tsx:330
msgid "Machine: {selectedMachineName}"
msgstr "Machine : {selectedMachineName}"

#: src/routes/CustomerDetail.tsx:651
#: src/routes/Monitoring.tsx:85
#: src/routes/Monitoring.tsx:118
msgid "Machines"
msgstr "Machines"

#: src/routes/Customers.tsx:79
msgid "Manage →"
msgstr "Gérer →"

#: src/routes/LlmModels.tsx:470
msgid "Manage system prompts"
msgstr "Gérer les prompts système"

#: src/routes/Releases.tsx:339
msgid "Mark as required (agents will highlight this in the UI)"
msgstr "Marquer comme requise (les agents la mettront en évidence dans l'UI)"

#: src/routes/LlmModels.tsx:208
msgid "Max output"
msgstr "Sortie max"

#: src/routes/LlmModels.tsx:422
msgid "Max output tokens"
msgstr "Jetons de sortie max"

#: src/routes/NewConfig.tsx:452
msgid "Max rows per query"
msgstr "Lignes max par requête"

#: src/routes/Plans.tsx:379
msgid "Max tool calls per turn"
msgstr "Appels d'outils max par tour"

#: src/routes/LlmModels.tsx:441
msgid "Maximum"
msgstr "Maximum"

#: src/routes/LlmModels.tsx:438
msgid "Medium — recommended"
msgstr "Moyen — recommandé"

#: src/routes/Errors.tsx:388
#: src/routes/Errors.tsx:453
#: src/routes/Monitoring.tsx:255
msgid "Message"
msgstr "Message"

#: src/routes/ConversationDetail.tsx:243
msgid "Messages"
msgstr "Messages"

#: src/routes/Users.tsx:199
msgid "min 8 characters"
msgstr "8 caractères minimum"

#: src/feedback-labels.ts:11
msgid "Missing access rights"
msgstr "Manque de droits d'accès"

#: src/feedback-labels.ts:17
msgid "Misunderstood the question"
msgstr "A mal compris la question"

#: src/routes/Plans.tsx:139
#: src/routes/Plans.tsx:294
#: src/routes/SystemPrompts.tsx:324
#: src/routes/Usage.tsx:226
msgid "Model"
msgstr "Modèle"

#: src/routes/LlmModels.tsx:118
msgid "Model actions"
msgstr "Actions du modèle"

#: src/routes/Usage.tsx:217
msgid "Model calls the product makes for itself. Not billed to any customer, not counted in any quota — this is our own cost."
msgstr "Appels de modèle que le produit fait pour lui-même. Facturés à aucun client, comptés dans aucun quota — c'est notre propre coût."

#: src/routes/LlmModels.tsx:205
msgid "Model id"
msgstr "ID du modèle"

#: src/routes/ConversationDetail.tsx:195
#: src/routes/SystemPrompts.tsx:126
msgid "Models"
msgstr "Modèles"

#: src/components/Layout.tsx:171
#: src/routes/LlmModels.tsx:220
msgid "Models & prices"
msgstr "Modèles et prix"

#: src/components/FeatureSelector.tsx:137
msgid "Module"
msgstr "Module"

#: src/components/Layout.tsx:180
#: src/routes/Monitoring.tsx:76
msgid "Monitoring"
msgstr "Surveillance"

#: src/routes/Usage.tsx:61
msgid "Month"
msgstr "Mois"

#: src/routes/CustomerDetail.tsx:526
msgid "Monthly allowance"
msgstr "Allocation mensuelle"

#: src/routes/Plans.tsx:357
msgid "Monthly budget (USD)"
msgstr "Budget mensuel (USD)"

#: src/routes/Conversations.tsx:479
msgid "Msgs"
msgstr "Msgs"

#: src/features-catalog.ts:133
msgid "Multiple Contacts"
msgstr "Contacts multiples"

#: src/routes/CustomerDetail.tsx:658
#: src/routes/Customers.tsx:259
#: src/routes/Customers.tsx:382
#: src/routes/Plans.tsx:138
#: src/routes/Plans.tsx:290
#: src/routes/Users.tsx:70
#: src/routes/Users.tsx:187
msgid "Name"
msgstr "Nom"

#: src/routes/CustomerDetail.tsx:704
#: src/routes/Monitoring.tsx:308
#: src/routes/Users.tsx:87
msgid "never"
msgstr "jamais"

#: src/routes/Users.tsx:60
#: src/routes/Users.tsx:168
msgid "New account"
msgstr "Nouveau compte"

#: src/routes/Customers.tsx:247
#: src/routes/Customers.tsx:379
msgid "New customer"
msgstr "Nouveau client"

#: src/routes/LlmModels.tsx:221
#: src/routes/LlmModels.tsx:381
msgid "New model"
msgstr "Nouveau modèle"

#. placeholder {0}: u.email
#: src/routes/Users.tsx:38
msgid "New password for {0}:"
msgstr "Nouveau mot de passe pour {0} :"

#: src/routes/Plans.tsx:154
#: src/routes/Plans.tsx:277
msgid "New plan"
msgstr "Nouveau forfait"

#. placeholder {0}: model.displayName
#: src/routes/LlmModels.tsx:544
msgid "New price for {0}"
msgstr "Nouveau prix pour {0}"

#: src/routes/SystemPrompts.tsx:145
msgid "New prompt"
msgstr "Nouveau prompt"

#: src/routes/SystemPrompts.tsx:286
msgid "New system prompt"
msgstr "Nouveau prompt système"

#: src/routes/Usage.tsx:269
msgid "Next"
msgstr "Suivant"

#: src/routes/CustomerDetail.tsx:1440
#: src/routes/CustomerDetail.tsx:1441
msgid "Next page"
msgstr "Page suivante"

#: src/routes/Releases.tsx:95
msgid "no"
msgstr "non"

#: src/routes/SystemPrompts.tsx:341
msgid "No active model."
msgstr "Aucun modèle actif."

#: src/routes/SystemPrompts.tsx:157
msgid "No active prompts yet."
msgstr "Aucun prompt actif pour l'instant."

#: src/routes/Releases.tsx:184
msgid "No active releases."
msgstr "Aucune version active."

#: src/feedback-labels.ts:14
msgid "No answer at all"
msgstr "Aucune réponse"

#: src/routes/Releases.tsx:177
msgid "No app versions published yet."
msgstr "Aucune version d'app publiée pour l'instant."

#: src/routes/Releases.tsx:190
msgid "No archived releases."
msgstr "Aucune version archivée."

#: src/routes/AuditLog.tsx:146
msgid "No audit entries match."
msgstr "Aucune entrée d'audit ne correspond."

#: src/routes/ConversationDetail.tsx:489
msgid "No comment provided."
msgstr "Aucun commentaire fourni."

#: src/routes/NewConfig.tsx:314
msgid "No config yet for this customer. Saving creates the first revision and pushes it out."
msgstr "Aucune config pour ce client. L'enregistrement crée la première révision et la propage."

#: src/routes/CustomerDetail.tsx:776
msgid "No config yet."
msgstr "Aucune config pour l'instant."

#: src/routes/Conversations.tsx:462
msgid "No conversation matches these filters."
msgstr "Aucune conversation ne correspond à ces filtres."

#: src/routes/Customers.tsx:254
msgid "No customers yet."
msgstr "Aucun client pour l'instant."

#: src/routes/Errors.tsx:367
msgid "No errors match these filters."
msgstr "Aucune erreur ne correspond à ces filtres."

#: src/routes/Monitoring.tsx:194
msgid "No errors reported in the last 24h."
msgstr "Aucune erreur rapportée ces dernières 24 h."

#: src/routes/CustomerDetail.tsx:971
msgid "No feature active."
msgstr "Aucune fonctionnalité active."

#: src/routes/CustomerDetail.tsx:515
msgid "No licence issued yet."
msgstr "Aucune licence émise pour l'instant."

#: src/routes/CustomerDetail.tsx:637
msgid "No licence usage."
msgstr "Aucune utilisation par licence."

#: src/routes/LicenseSwaps.tsx:178
msgid "No license swaps match."
msgstr "Aucun changement de licence ne correspond."

#: src/routes/CustomerDetail.tsx:653
msgid "No machine registered yet."
msgstr "Aucune machine enregistrée pour l'instant."

#: src/routes/Monitoring.tsx:135
msgid "No machines match this filter."
msgstr "Aucune machine ne correspond à ce filtre."

#: src/routes/CustomerDetail.tsx:1432
#~ msgid "No model usage."
#~ msgstr "Aucune utilisation par modèle."

#: src/routes/LlmModels.tsx:158
msgid "No price version yet."
msgstr "Aucune version de prix pour l'instant."

#: src/routes/CustomerDetail.tsx:1529
msgid "No prior months on record."
msgstr "Aucun mois antérieur enregistré."

#: src/routes/ConversationDetail.tsx:283
msgid "No recorded requests."
msgstr "Aucune requête enregistrée."

#: src/routes/Monitoring.tsx:246
msgid "No runtime errors in the last 24h."
msgstr "Aucune erreur d'exécution ces dernières 24 h."

#: src/components/RequestPricing.tsx:34
msgid "No threshold recorded"
msgstr "Aucun seuil enregistré"

#: src/routes/Usage.tsx:158
msgid "No usage recorded this month."
msgstr "Aucune utilisation enregistrée ce mois-ci."

#: src/routes/LlmModels.tsx:436
msgid "None — lowest latency"
msgstr "Aucun — latence minimale"

#: src/components/FeatureSelector.tsx:192
msgid "not applicable"
msgstr "non applicable"

#: src/routes/Conversations.tsx:79
msgid "Not flagged"
msgstr "Non signalées"

#: src/routes/ConversationDetail.tsx:388
msgid "Note (optional)"
msgstr "Note (facultative)"

#: src/routes/ConversationDetail.tsx:388
msgid "Note (required)"
msgstr "Note (obligatoire)"

#: src/routes/Customers.tsx:403
msgid "Notes"
msgstr "Notes"

#: src/routes/SealSecrets.tsx:163
msgid "Nothing to change."
msgstr "Rien à modifier."

#: src/routes/CustomerDetail.tsx:557
msgid "Occupied"
msgstr "Occupée"

#: src/components/FeatureSelector.tsx:140
msgid "OData create / update / delete"
msgstr "OData créer / modifier / supprimer"

#: src/components/FeatureSelector.tsx:139
msgid "OData list / get / search"
msgstr "OData lister / obtenir / rechercher"

#: src/routes/Monitoring.tsx:126
#: src/routes/Monitoring.tsx:164
msgid "offline"
msgstr "hors ligne"

#: src/routes/Monitoring.tsx:87
msgid "Offline"
msgstr "Hors ligne"

#. placeholder {0}: summary.offlineThresholdMinutes
#: src/routes/Monitoring.tsx:112
msgid "Offline threshold: {0} min without heartbeat."
msgstr "Seuil hors ligne : {0} min sans battement."

#: src/routes/Monitoring.tsx:296
msgid "ok"
msgstr "ok"

#: src/routes/AuditLog.tsx:165
#: src/routes/LicenseSwaps.tsx:197
msgid "Older →"
msgstr "Plus ancien →"

#: src/components/RequestPricing.tsx:48
msgid "Omitted cache rates use this request's selected input rate. Explicit zero rates remain zero. Historical costs are displayed as recorded."
msgstr "Les tarifs de cache omis utilisent le tarif d’entrée sélectionné pour cette requête. Les tarifs explicitement nuls restent nuls. Les coûts historiques sont affichés tels qu’enregistrés."

#: src/routes/Monitoring.tsx:126
#: src/routes/Monitoring.tsx:164
msgid "online"
msgstr "en ligne"

#: src/routes/Monitoring.tsx:86
msgid "Online"
msgstr "En ligne"

#: src/routes/LlmModels.tsx:444
msgid "Only applied to OpenAI models; Anthropic ignores this field."
msgstr "Appliqué uniquement aux modèles OpenAI ; Anthropic ignore ce champ."

#: src/routes/Releases.tsx:104
msgid "open"
msgstr "ouvrir"

#: src/components/TransferLicenseDialog.tsx:31
msgid "Open Machine identity on the replacement desktop and copy its fingerprint here."
msgstr "Ouvrez Identité de la machine dans l’application du remplacement et copiez son empreinte ici."

#: src/components/Layout.tsx:178
msgid "Operations"
msgstr "Opérations"

#: src/routes/Users.tsx:190
msgid "optional"
msgstr "facultatif"

#: src/features-catalog.ts:72
msgid "Order Entry"
msgstr "Saisie de commandes"

#: src/routes/Errors.tsx:245
#: src/routes/Errors.tsx:383
#: src/routes/Monitoring.tsx:253
msgid "Origin"
msgstr "Origine"

#: src/credit-reason-labels.ts:20
#: src/feedback-labels.ts:19
msgid "Other"
msgstr "Autre"

#: src/routes/ConversationDetail.tsx:446
msgid "out"
msgstr "out"

#: src/routes/LicenseSwaps.tsx:84
#: src/routes/LicenseSwaps.tsx:133
msgid "Outcome"
msgstr "Résultat"

#: src/routes/Conversations.tsx:484
#: src/routes/Usage.tsx:229
msgid "Output"
msgstr "Sortie"

#: src/routes/LlmModels.tsx:592
#: src/routes/LlmModels.tsx:632
msgid "Output $/1M tokens"
msgstr "Sortie $/1M jetons"

#: src/routes/LlmModels.tsx:170
msgid "Output $/Mtok"
msgstr "Sortie $/Mjet"

#: src/components/RequestPricing.tsx:44
#: src/routes/ConversationDetail.tsx:267
#: src/routes/ConversationDetail.tsx:445
#: src/routes/CustomerDetail.tsx:634
#: src/routes/CustomerDetail.tsx:1356
#: src/routes/Usage.tsx:89
msgid "Output tokens"
msgstr "Jetons de sortie"

#. placeholder {0}: creditedPageSafe + 1
#: src/routes/CustomerDetail.tsx:1425
msgid "Page {0} of {creditedPageCount}"
msgstr "Page {0} sur {creditedPageCount}"

#. placeholder {0}: Math.max(1, Math.ceil(data.requestPagination.total / data.requestPagination.pageSize))
#: src/routes/Usage.tsx:268
msgid "Page {page} of {0}"
msgstr "Page {page} sur {0}"

#: src/routes/Login.tsx:32
#: src/routes/Users.tsx:196
msgid "Password"
msgstr "Mot de passe"

#: src/routes/Users.tsx:41
#: src/routes/Users.tsx:146
msgid "Password must be at least 8 characters."
msgstr "Le mot de passe doit faire au moins 8 caractères."

#: src/routes/Users.tsx:47
msgid "Password updated."
msgstr "Mot de passe mis à jour."

#: src/routes/NewConfig.tsx:566
msgid "Passwords are not set here. Once this config is saved, use \"Seal secrets\" on each machine to choose which companies that machine may query and send their credentials encrypted."
msgstr "Les mots de passe ne sont pas définis ici. Une fois la config enregistrée, utilise « Sceller les secrets » sur chaque machine pour choisir les sociétés qu'elle peut interroger et envoyer leurs identifiants chiffrés."

#: src/routes/SealSecrets.tsx:256
msgid "Passwords typed below are sealed in this browser with the machine's public key and never sent in the clear. After sealing, the plaintext is discarded from the form."
msgstr "Les mots de passe saisis ci-dessous sont scellés dans ce navigateur avec la clé publique de la machine et ne sont jamais envoyés en clair. Après scellement, le texte en clair est effacé du formulaire."

#: src/routes/CustomerDetail.tsx:466
msgid "Pause (unpaid)"
msgstr "Mettre en pause (impayé)"

#. placeholder {0}: customer.name
#: src/routes/CustomerDetail.tsx:350
msgid "Pause {0} for non-payment? Access is cut until you unpause. Optional note:"
msgstr "Mettre {0} en pause pour impayé ? L'accès est coupé jusqu'à la reprise. Note facultative :"

#: src/routes/Customers.tsx:35
msgid "paused"
msgstr "en pause"

#: src/routes/CustomerDetail.tsx:489
msgid "Paused for non-payment"
msgstr "En pause pour impayé"

#: src/components/FeatureSelector.tsx:61
msgid "Pick what the LLM is allowed to touch. <0>.write</0> and <1>.read</1> per module control the Sage Web API; <2>db.*.read</2> control the read-only SQL surface. See <3>docs/permissions.md</3> for the full reference."
msgstr "Choisissez ce que le LLM peut toucher. <0>.write</0> et <1>.read</1> par module contrôlent l'API Web Sage ; <2>db.*.read</2> contrôlent la surface SQL en lecture seule. Voir <3>docs/permissions.md</3> pour la référence complète."

#: src/components/ChangeLicensePlanDialog.tsx:53
#: src/routes/CustomerDetail.tsx:522
#: src/routes/CustomerDetail.tsx:1192
#: src/routes/Usage.tsx:103
msgid "Plan"
msgstr "Forfait"

#: src/routes/AuditLog.tsx:69
msgid "plan / customer / license…"
msgstr "forfait / client / licence…"

#: src/routes/Plans.tsx:104
msgid "Plan actions"
msgstr "Actions du forfait"

#: src/components/Layout.tsx:170
#: src/routes/Plans.tsx:153
msgid "Plans"
msgstr "Forfaits"

#: src/routes/Usage.tsx:256
msgid "Platform requests"
msgstr "Requêtes de la plateforme"

#: src/routes/Usage.tsx:215
msgid "Platform spend (Jalfa)"
msgstr "Dépense plateforme (Jalfa)"

#: src/routes/SystemPrompts.tsx:123
msgid "Preview"
msgstr "Aperçu"

#: src/routes/Usage.tsx:267
msgid "Previous"
msgstr "Précédent"

#: src/routes/CustomerDetail.tsx:1431
#: src/routes/CustomerDetail.tsx:1432
msgid "Previous page"
msgstr "Page précédente"

#: src/routes/LlmModels.tsx:122
msgid "Prices"
msgstr "Prix"

#: src/routes/LlmModels.tsx:166
msgid "Pricing tier"
msgstr "Palier tarifaire"

#: src/credit-reason-labels.ts:12
msgid "Product bug"
msgstr "Bogue produit"

#: src/features-catalog.ts:87
msgid "Project & Job Costing"
msgstr "Comptabilité de projets et de travaux"

#: src/components/ChangeLicensePlanDialog.tsx:66
msgid "Proposed retention: {proposedDays} days."
msgstr "Conservation proposée : {proposedDays} jours."

#: src/routes/LlmModels.tsx:204
#: src/routes/LlmModels.tsx:384
msgid "Provider"
msgstr "Fournisseur"

#: src/routes/LlmModels.tsx:395
msgid "Provider model id"
msgstr "ID de modèle fournisseur"

#: src/routes/ConversationDetail.tsx:275
msgid "Provider request pricing"
msgstr "Tarification des requêtes au fournisseur"

#: src/routes/Releases.tsx:361
msgid "Publish"
msgstr "Publier"

#: src/routes/Releases.tsx:167
#: src/routes/Releases.tsx:278
msgid "Publish new version"
msgstr "Publier une nouvelle version"

#: src/routes/Releases.tsx:147
msgid "Published"
msgstr "Publiée"

#: src/features-catalog.ts:64
msgid "Purchase Orders"
msgstr "Bons de commande"

#: src/routes/Usage.tsx:225
msgid "Purpose"
msgstr "Usage"

#: src/routes/Usage.tsx:260
msgid "Question rewrite"
msgstr "Reformulation de question"

#: src/routes/Plans.tsx:326
msgid "Question rewrite model"
msgstr "Modèle de reformulation de question"

#: src/routes/Conversations.tsx:78
msgid "Rated"
msgstr "Évaluées"

#: src/routes/Users.tsx:102
msgid "Re-enable"
msgstr "Réactiver"

#: src/routes/CustomerDetail.tsx:597
#: src/routes/CustomerDetail.tsx:730
#: src/routes/LlmModels.tsx:146
#: src/routes/Plans.tsx:124
msgid "Reactivate"
msgstr "Réactiver"

#. placeholder {0}: customer.name
#: src/routes/CustomerDetail.tsx:335
msgid "Reactivate {0}? Licences resume at the next agent request."
msgstr "Réactiver {0} ? Les licences reprennent à la prochaine requête d'agent."

#: src/routes/CustomerDetail.tsx:442
msgid "Reactivate customer"
msgstr "Réactiver le client"

#. placeholder {0}: l.licenseKey
#: src/routes/CustomerDetail.tsx:266
msgid "Reactivate licence {0}?"
msgstr "Réactiver la licence {0} ?"

#. placeholder {0}: m.displayName
#: src/routes/LlmModels.tsx:79
msgid "Reactivate model \"{0}\"?"
msgstr "Réactiver le modèle « {0} » ?"

#. placeholder {0}: p.code
#: src/routes/Plans.tsx:57
msgid "Reactivate plan \"{0}\"?"
msgstr "Réactiver le forfait « {0} » ?"

#: src/routes/NewConfig.tsx:543
msgid "Reactivate this company"
msgstr "Réactiver cette société"

#: src/routes/CustomerDetail.tsx:237
msgid "Reactivate this machine? The agent will resume at its next request."
msgstr "Réactiver cette machine ? L'agent reprendra à sa prochaine requête."

#: src/components/FeatureSelector.tsx:138
msgid "Read-only SQL query tool (sage300_db_*_query)"
msgstr "Outil de requête SQL en lecture seule (sage300_db_*_query)"

#: src/routes/ConversationDetail.tsx:375
#: src/routes/CustomerDetail.tsx:1395
msgid "Reason"
msgstr "Raison"

#: src/routes/LlmModels.tsx:209
msgid "Reasoning"
msgstr "Raisonnement"

#: src/routes/LlmModels.tsx:431
msgid "Reasoning effort"
msgstr "Effort de raisonnement"

#: src/routes/CustomerDetail.tsx:1063
msgid "Reassign"
msgstr "Réassigner"

#: src/routes/CustomerDetail.tsx:409
#: src/routes/CustomerDetail.tsx:1034
msgid "Reassign reseller"
msgstr "Réassigner le revendeur"

#. placeholder {0}: new Date(entry.receivedAt).toLocaleString(i18n.locale)
#. placeholder {1}: entry.id
#: src/routes/Errors.tsx:487
msgid "Received {0} · id {1}"
msgstr "Reçu le {0} · id {1}"

#: src/routes/Monitoring.tsx:191
msgid "Recent errors (24h)"
msgstr "Erreurs récentes (24 h)"

#: src/routes/ConversationDetail.tsx:276
msgid "Recorded customer costs and rates. Input tokens include cache reads and writes. Rates are USD per million tokens."
msgstr "Coûts et tarifs client enregistrés. Les jetons en entrée incluent les lectures et écritures du cache. Les tarifs sont en USD par million de jetons."

#: src/components/RequestPricing.tsx:39
msgid "Recorded rate (USD / million tokens)"
msgstr "Tarif enregistré (USD / million de jetons)"

#: src/routes/AuditLog.tsx:84
#: src/routes/Conversations.tsx:253
#: src/routes/Errors.tsx:177
#: src/routes/LicenseSwaps.tsx:112
#: src/routes/Monitoring.tsx:78
#: src/routes/Usage.tsx:69
msgid "Refresh"
msgstr "Actualiser"

#: src/routes/Conversations.tsx:253
#: src/routes/Errors.tsx:177
msgid "Refreshing…"
msgstr "Actualisation…"

#: src/routes/LicenseSwaps.tsx:94
msgid "rejected"
msgstr "rejeté"

#: src/routes/Releases.tsx:110
msgid "Release actions"
msgstr "Actions de la version"

#: src/routes/Releases.tsx:342
msgid "Release notes (Markdown)"
msgstr "Notes de version (Markdown)"

#: src/components/Layout.tsx:197
#: src/routes/Releases.tsx:164
msgid "Releases"
msgstr "Versions"

#: src/routes/Usage.tsx:112
msgid "Remaining allowance"
msgstr "Allocation restante"

#: src/routes/Usage.tsx:93
msgid "Remaining allowance shows budget and hard cap slack for each licence."
msgstr "L’allocation restante indique le budget restant et la marge du plafond strict de chaque licence."

#: src/routes/CustomerDetail.tsx:625
msgid "Remaining budget"
msgstr "Budget restant"

#: src/routes/CustomerDetail.tsx:752
#: src/routes/NewConfig.tsx:298
msgid "Remote config"
msgstr "Config distante"

#: src/routes/ConversationDetail.tsx:136
msgid "Remove credit"
msgstr "Retirer le crédit"

#: src/routes/Errors.tsx:514
msgid "Remove filter"
msgstr "Retirer le filtre"

#: src/routes/ConversationDetail.tsx:58
msgid "Remove the credit? This conversation becomes billable again and reappears in the customer's app."
msgstr "Retirer le crédit ? Cette conversation redevient facturable et réapparaît dans l'application du client."

#. placeholder {0}: c.originalId
#: src/routes/NewConfig.tsx:409
msgid "Renaming \"{0}\" will orphan its sealed passwords — every machine will have to be re-sealed for this company."
msgstr "Renommer « {0} » rendra ses mots de passe scellés orphelins — chaque machine devra être re-scellée pour cette société."

#: src/routes/CustomerDetail.tsx:848
msgid "Replacement authorized"
msgstr "Remplacement autorisé"

#: src/components/TransferLicenseDialog.tsx:35
msgid "Replacement public key fingerprint"
msgstr "Empreinte de la clé publique du remplacement"

#: src/routes/ConversationDetail.tsx:475
msgid "reported"
msgstr "signalée"

#: src/routes/Conversations.tsx:391
msgid "Reported reason"
msgstr "Motif signalé"

#: src/routes/Conversations.tsx:571
msgid "Reported without a reason"
msgstr "Signalée sans motif"

#: src/components/RequestPricing.tsx:24
msgid "Request"
msgstr "Requête"

#: src/routes/Errors.tsx:463
msgid "Request ID"
msgstr "ID de requête"

#: src/routes/ConversationDetail.tsx:289
msgid "Requests without a turn (including titles)"
msgstr "Requêtes sans tour (y compris les titres)"

#: src/routes/Releases.tsx:146
msgid "Required"
msgstr "Requise"

#: src/routes/CustomerDetail.tsx:407
#: src/routes/CustomerDetail.tsx:1043
#: src/routes/Customers.tsx:232
#: src/routes/Customers.tsx:261
#: src/routes/Users.tsx:84
msgid "Reseller"
msgstr "Revendeur"

#: src/routes/Users.tsx:174
msgid "Reseller (scoped to their own customers)"
msgstr "Revendeur (limité à ses propres clients)"

#: src/routes/CustomerDetail.tsx:1540
msgid "Reservation"
msgstr "Réservation"

#: src/routes/Conversations.tsx:250
#: src/routes/Errors.tsx:174
msgid "Reset"
msgstr "Réinitialiser"

#: src/routes/Users.tsx:95
msgid "Reset password"
msgstr "Réinitialiser le mot de passe"

#: src/routes/Plans.tsx:142
msgid "Retention"
msgstr "Rétention"

#: src/routes/Plans.tsx:388
msgid "Retention (days)"
msgstr "Rétention (jours)"

#. placeholder {0}: c.version
#. placeholder {1}: new Date(c.createdAt).toLocaleString(i18n.locale)
#. placeholder {2}: activeId ? ` · default ${activeId}` : ""
#: src/routes/CustomerDetail.tsx:760
msgid "rev {0} · {1}{2}"
msgstr "rév. {0} · {1}{2}"

#: src/routes/CustomerDetail.tsx:721
msgid "Revoke"
msgstr "Révoquer"

#: src/routes/CustomerDetail.tsx:224
msgid "Revoke this machine? The agent will be locked out at the next request."
msgstr "Révoquer cette machine ? L'agent sera bloqué à la prochaine requête."

#: src/routes/Monitoring.tsx:88
msgid "Revoked"
msgstr "Révoquées"

#: src/routes/CustomerDetail.tsx:557
msgid "Revoking previous access"
msgstr "Révocation de l’ancien accès"

#. placeholder {0}: rewriteModel.displayName
#: src/routes/Plans.tsx:94
msgid "rewrite: {0}"
msgstr "reformulation : {0}"

#: src/routes/Plans.tsx:339
msgid "Rewrites the user's question into the English accounting vocabulary of the Sage schema before the database discovery tools search it — the metadata is in English and the questions are not. Cheapest active model; leaving it off falls back to the built-in French lexicon. Billed to Jalfa, not to the customer (Usage → platform spend)."
msgstr "Reformule la question de l'utilisateur dans le vocabulaire comptable anglais du schéma Sage avant que les outils de découverte de la base ne la cherchent — les métadonnées sont en anglais, pas les questions. Prendre le modèle actif le moins cher ; désactivé, on retombe sur le lexique français intégré. Facturé à Jalfa, pas au client (Usage → dépense plateforme)."

#: src/routes/Users.tsx:71
#: src/routes/Users.tsx:171
msgid "Role"
msgstr "Rôle"

#: src/routes/Monitoring.tsx:105
#: src/routes/Monitoring.tsx:242
msgid "Runtime errors (24h)"
msgstr "Erreurs d'exécution (24 h)"

#. placeholder {0}: index + 1
#: src/routes/NewConfig.tsx:345
msgid "Sage 300 company {0}"
msgstr "Société Sage 300 {0}"

#: src/routes/SealSecrets.tsx:308
msgid "Sage 300 Web API password"
msgstr "Mot de passe de l'API Web Sage 300"

#: src/components/TransferLicenseDialog.tsx:33
msgid "Sage credentials and local files are not copied. Configure and seal Sage access on the replacement, including the company selected by each retained conversation."
msgstr "Les identifiants Sage et les fichiers locaux ne sont pas copiés. Configurez et scellez l’accès Sage sur le remplacement, y compris la société sélectionnée par chaque conversation conservée."

#: src/features-catalog.ts:128
msgid "Sage CRM Integration"
msgstr "Intégration Sage CRM"

#: src/features-catalog.ts:123
msgid "Sage Fixed Assets Integration"
msgstr "Intégration Sage Immobilisations"

#: src/routes/Monitoring.tsx:145
msgid "Sage SQL"
msgstr "Sage SQL"

#: src/routes/CustomerDetail.tsx:429
#: src/routes/CustomerDetail.tsx:1113
msgid "Sage version"
msgstr "Version de Sage"

#: src/routes/CustomerDetail.tsx:792
#: src/routes/Monitoring.tsx:146
#: src/routes/NewConfig.tsx:485
msgid "Sage Web API"
msgstr "API Web Sage"

#: src/feedback-labels.ts:12
msgid "Said it could not answer"
msgstr "A dit ne pas pouvoir répondre"

#: src/routes/CustomerDetail.tsx:1132
#: src/routes/CustomerDetail.tsx:1304
#: src/routes/LlmModels.tsx:479
#: src/routes/LlmModels.tsx:644
#: src/routes/NewConfig.tsx:589
#: src/routes/Plans.tsx:402
#: src/routes/Releases.tsx:359
#: src/routes/SystemPrompts.tsx:379
msgid "Save"
msgstr "Enregistrer"

#: src/components/ChangeLicensePlanDialog.tsx:80
#: src/components/TransferLicenseDialog.tsx:47
#: src/routes/CustomerDetail.tsx:1063
#: src/routes/CustomerDetail.tsx:1132
#: src/routes/CustomerDetail.tsx:1304
#: src/routes/LlmModels.tsx:479
#: src/routes/LlmModels.tsx:644
#: src/routes/NewConfig.tsx:589
#: src/routes/Plans.tsx:402
#: src/routes/Releases.tsx:357
#: src/routes/SystemPrompts.tsx:379
msgid "Saving…"
msgstr "Enregistrement…"

#: src/routes/SealSecrets.tsx:351
msgid "Seal & upload"
msgstr "Sceller et téléverser"

#: src/routes/CustomerDetail.tsx:708
#: src/routes/CustomerDetail.tsx:713
#: src/routes/SealSecrets.tsx:240
msgid "Seal secrets"
msgstr "Sceller les secrets"

#: src/routes/SealSecrets.tsx:215
msgid "Sealed {stored} secret(s) and revoked {deleted}. The machine will pick up the change over the WebSocket push — no restart needed."
msgstr "{stored} secret(s) scellé(s) et {deleted} révoqué(s). La machine reçoit le changement par push WebSocket — aucun redémarrage requis."

#: src/routes/SealSecrets.tsx:351
msgid "Sealing…"
msgstr "Scellement…"

#: src/routes/Conversations.tsx:268
msgid "Search by title…"
msgstr "Rechercher par titre…"

#: src/routes/Errors.tsx:192
msgid "Search message, source or error code…"
msgstr "Chercher un message, une source ou un code d'erreur…"

#: src/routes/Plans.tsx:234
msgid "Select a model first"
msgstr "Sélectionnez d'abord un modèle"

#: src/routes/CustomerDetail.tsx:1194
msgid "Select a plan"
msgstr "Sélectionnez un forfait"

#: src/routes/LlmModels.tsx:460
msgid "Select a system prompt…"
msgstr "Sélectionner un prompt système…"

#: src/components/FeatureSelector.tsx:71
msgid "Select all SQL read"
msgstr "Sélectionner toute la lecture SQL"

#: src/components/FeatureSelector.tsx:78
msgid "Select all Web API read"
msgstr "Sélectionner toute la lecture Web API"

#: src/components/FeatureSelector.tsx:86
msgid "Select all Web API write + post"
msgstr "Sélectionner toute l'écriture + report Web API"

#: src/routes/CustomerDetail.tsx:1186
msgid "Select this licence's plan before installation. Its plan provides an independent monthly allowance."
msgstr "Sélectionnez le plan de cette licence avant l’installation. Son plan fournit une allocation mensuelle indépendante."

#: src/routes/NewConfig.tsx:431
msgid "Server"
msgstr "Serveur"

#: src/routes/CustomerDetail.tsx:768
msgid "Set up"
msgstr "Configurer"

#: src/routes/Releases.tsx:150
msgid "SHA-256"
msgstr "SHA-256"

#: src/routes/Releases.tsx:320
msgid "SHA-256 (64 hex chars)"
msgstr "SHA-256 (64 caractères hex)"

#: src/components/ChangeLicensePlanDialog.tsx:69
msgid "Shortening retention will permanently delete existing history older than {proposedDays} days at the next retention sweep. Changing plans does not restart the age of existing history."
msgstr "Réduire la durée de conservation supprimera définitivement l'historique de plus de {proposedDays} jours lors de la prochaine purge. Changer de forfait ne remet pas à zéro l'âge de l'historique existant."

#: src/routes/NewConfig.tsx:364
msgid "Shown to the user in the app when they pick a company."
msgstr "Affiché à l'utilisateur dans l'application au moment de choisir une société."

#: src/routes/Login.tsx:43
msgid "Sign in"
msgstr "Se connecter"

#: src/routes/Login.tsx:19
msgid "Sign in with your administrator account."
msgstr "Connectez-vous avec votre compte administrateur."

#: src/components/Layout.tsx:246
msgid "Sign out"
msgstr "Se déconnecter"

#: src/routes/Releases.tsx:330
msgid "Signature (optional, base64)"
msgstr "Signature (optionnelle, base64)"

#: src/auth.tsx:208
msgid "Signed out after {IDLE_TIMEOUT_MINUTES} minutes without activity. Please sign in again."
msgstr "Déconnecté après {IDLE_TIMEOUT_MINUTES} minutes d’inactivité. Veuillez vous reconnecter."

#: src/routes/Login.tsx:43
msgid "Signing in…"
msgstr "Connexion…"

#. placeholder {0}: new Date(customer.deactivatedAt).toLocaleString(i18n.locale)
#. placeholder {0}: new Date(customer.pausedAt).toLocaleString(i18n.locale)
#: src/routes/CustomerDetail.tsx:479
#: src/routes/CustomerDetail.tsx:491
msgid "since {0}"
msgstr "depuis {0}"

#: src/routes/Errors.tsx:387
#: src/routes/Monitoring.tsx:201
#: src/routes/Monitoring.tsx:254
msgid "Source"
msgstr "Source"

#: src/routes/Usage.tsx:106
msgid "Spent (mo)"
msgstr "Dépensé (mois)"

#: src/components/FeatureSelector.tsx:138
#: src/features-catalog.ts:160
msgid "SQL read"
msgstr "Lecture SQL"

#: src/routes/CustomerDetail.tsx:791
msgid "SQL Server"
msgstr "SQL Server"

#: src/routes/NewConfig.tsx:429
msgid "SQL Server (read-only)"
msgstr "SQL Server (lecture seule)"

#: src/routes/SealSecrets.tsx:319
msgid "SQL Server password"
msgstr "Mot de passe SQL Server"

#: src/routes/Errors.tsx:476
msgid "Stack"
msgstr "Pile"

#: src/components/RequestPricing.tsx:31
#: src/routes/LlmModels.tsx:178
msgid "Standard"
msgstr "Standard"

#: src/routes/CustomerDetail.tsx:523
#: src/routes/CustomerDetail.tsx:629
#: src/routes/CustomerDetail.tsx:659
#: src/routes/CustomerDetail.tsx:793
#: src/routes/Monitoring.tsx:143
#: src/routes/Usage.tsx:113
#: src/routes/Users.tsx:73
msgid "Status"
msgstr "Statut"

#: src/routes/CustomerDetail.tsx:1346
msgid "Summed licence allowances"
msgstr "Somme des allocations des licences"

#: src/routes/CustomerDetail.tsx:1347
msgid "Summed licence hard caps"
msgstr "Somme des plafonds stricts des licences"

#: src/routes/Users.tsx:85
msgid "Superuser"
msgstr "Superutilisateur"

#: src/routes/Users.tsx:173
msgid "Superuser (Jalfa employee — full access)"
msgstr "Superutilisateur (employé Jalfa — accès complet)"

#: src/credit-reason-labels.ts:15
msgid "Support investigation"
msgstr "Investigation du support"

#: src/routes/CustomerDetail.tsx:605
msgid "Suspend"
msgstr "Suspendre"

#. placeholder {0}: l.licenseKey
#: src/routes/CustomerDetail.tsx:252
msgid "Suspend licence {0}? Agents on this key will stop working immediately."
msgstr "Suspendre la licence {0} ? Les agents utilisant cette clé cesseront de fonctionner immédiatement."

#: src/routes/LicenseSwaps.tsx:107
msgid "swap_check"
msgstr "swap_check"

#: src/routes/LicenseSwaps.tsx:108
msgid "swap_commit"
msgstr "swap_commit"

#: src/components/Layout.tsx:191
msgid "System"
msgstr "Système"

#: src/routes/LlmModels.tsx:448
msgid "System prompt"
msgstr "Prompt système"

#: src/routes/SystemPrompts.tsx:87
msgid "System prompt actions"
msgstr "Actions du prompt système"

#: src/routes/LlmModels.tsx:339
msgid "System prompt is required"
msgstr "Le prompt système est requis"

#: src/components/Layout.tsx:196
#: src/routes/SystemPrompts.tsx:142
msgid "System prompts"
msgstr "Prompts système"

#: src/routes/LicenseSwaps.tsx:131
msgid "Target license"
msgstr "Licence cible"

#: src/features-catalog.ts:145
msgid "Tax Services"
msgstr "Services de taxes"

#: src/credit-reason-labels.ts:14
#: src/feedback-labels.ts:18
msgid "Technical or tool error"
msgstr "Erreur technique ou d'outil"

#: src/routes/NewConfig.tsx:502
msgid "Tenant"
msgstr "Locataire"

#: src/routes/CustomerDetail.tsx:1036
msgid "The customer keeps its licences, machines and history — only the ownership changes. The new reseller sees this customer on their next dashboard load."
msgstr "Le client conserve ses licences, machines et historique — seul le propriétaire change. Le nouveau revendeur verra ce client au prochain chargement de son tableau de bord."

#: src/routes/Releases.tsx:281
msgid "The download URL must serve the exact bytes hashed by <0>sha256</0>. Agents refuse to install any package whose SHA-256 does not match."
msgstr "L'URL de téléchargement doit servir les octets exacts hashés par <0>sha256</0>. Les agents refusent d'installer tout paquet dont le SHA-256 ne correspond pas."

#: src/components/TransferLicenseDialog.tsx:32
msgid "The previous machine will lose access and the licence key will rotate. History, plan, permissions and consumption stay with this licence."
msgstr "L’ancienne machine perdra son accès et la clé de licence sera renouvelée. L’historique, le forfait, les permissions et la consommation restent liés à cette licence."

#: src/routes/SealSecrets.tsx:276
msgid "The remote config declares no company yet."
msgstr "La config distante ne déclare encore aucune société."

#: src/routes/CustomerDetail.tsx:1386
msgid "These conversations are billed to nobody and are hidden from the customer's app. Together they account for the credited total above."
msgstr "Ces conversations ne sont facturées à personne et sont masquées dans l'application du client. Ensemble, elles justifient le total crédité ci-dessus."

#: src/routes/SealSecrets.tsx:330
msgid "This company has neither complete SQL nor complete Web API settings, so there is no password to seal. Fix the config first."
msgstr "Cette société n'a ni paramètres SQL complets ni paramètres Web API complets : il n'y a aucun mot de passe à sceller. Corrigez d'abord la config."

#: src/routes/ConversationDetail.tsx:297
msgid "This conversation has no messages yet."
msgstr "Cette conversation n'a pas encore de messages."

#: src/routes/ConversationDetail.tsx:209
msgid "This conversation is billed to nobody and is hidden from the customer's app."
msgstr "Cette conversation n'est facturée à personne et est masquée dans l'application du client."

#: src/routes/NewConfig.tsx:401
msgid "This id is used by another company. Ids prefix the sealed secret keys, so two companies cannot share one."
msgstr "Cet id est déjà utilisé par une autre société. Les ids préfixent les clés de secrets scellés : deux sociétés ne peuvent pas le partager."

#: src/routes/CustomerDetail.tsx:244
msgid "This license is occupied or the machine has no license. Administrator authorization is required before it can return."
msgstr "Cette licence est occupée ou la machine n’a pas de licence. Une autorisation de l’administrateur est requise pour son retour."

#: src/routes/SealSecrets.tsx:168
msgid "This machine will lose access to: {names}. Continue?"
msgstr "Cette machine perdra l'accès à : {names}. Continuer ?"

#: src/routes/SealSecrets.tsx:268
msgid "Tick a company to give this machine access to its database. Leave a password blank on an already-sealed company to keep the current one."
msgstr "Cochez une société pour donner à cette machine l'accès à sa base de données. Laissez un mot de passe vide sur une société déjà scellée pour conserver l'actuel."

#: src/routes/Conversations.tsx:285
#: src/routes/Errors.tsx:209
msgid "Time range"
msgstr "Plage temporelle"

#: src/routes/Conversations.tsx:475
msgid "Title"
msgstr "Titre"

#: src/routes/ConversationDetail.tsx:231
msgid "Title cost"
msgstr "Coût du titre"

#: src/routes/Plans.tsx:305
msgid "Title model"
msgstr "Modèle de titre"

#. placeholder {0}: titleModel.displayName
#: src/routes/Plans.tsx:89
msgid "titles: {0}"
msgstr "titres : {0}"

#: src/components/RequestPricing.tsx:39
msgid "Token usage"
msgstr "Utilisation des jetons"

#: src/components/RequestPricing.tsx:39
#: src/routes/SystemPrompts.tsx:327
msgid "Tokens"
msgstr "Jetons"

#: src/routes/SystemPrompts.tsx:313
msgid "Tokens estimated at ~4 characters per token; cost uses each active model's current input tariff."
msgstr "Jetons estimés à ~4 caractères par jeton ; le coût utilise le tarif d'entrée courant de chaque modèle actif."

#: src/routes/CustomerDetail.tsx:627
#: src/routes/Plans.tsx:141
#: src/routes/Usage.tsx:111
msgid "Tolerance"
msgstr "Tolérance"

#: src/routes/Plans.tsx:368
msgid "Tolerance (%)"
msgstr "Tolérance (%)"

#: src/routes/Conversations.tsx:67
msgid "Tool error"
msgstr "Erreur d'outil"

#: src/routes/Usage.tsx:248
msgid "Total"
msgstr "Total"

#. placeholder {0}: formatCost(totals.cost, i18n.locale)
#: src/routes/Conversations.tsx:449
msgid "total {0}"
msgstr "total {0}"

#: src/routes/ConversationDetail.tsx:218
#: src/routes/CustomerDetail.tsx:1345
#: src/routes/Usage.tsx:79
msgid "Total cost"
msgstr "Coût total"

#: src/components/TransferLicenseDialog.tsx:30
#: src/routes/CustomerDetail.tsx:584
msgid "Transfer licence"
msgstr "Transférer la licence"

#: src/routes/ConversationDetail.tsx:426
msgid "truncated (quota)"
msgstr "tronqué (quota)"

#: src/routes/NewConfig.tsx:479
msgid "Trust server certificate (required on stock Sage 300 installs with a self-signed SQL Server cert)"
msgstr "Faire confiance au certificat du serveur (requis pour les installations Sage 300 standard avec un certificat SQL Server auto-signé)"

#: src/routes/CustomerDetail.tsx:1541
msgid "Turn"
msgstr "Tour"

#. placeholder {0}: index + 1
#: src/routes/ConversationDetail.tsx:280
msgid "Turn {0}"
msgstr "Tour {0}"

#: src/routes/Conversations.tsx:68
msgid "Turn error"
msgstr "Erreur de tour"

#: src/routes/ConversationDetail.tsx:237
#: src/routes/Conversations.tsx:480
#: src/routes/CustomerDetail.tsx:635
#: src/routes/CustomerDetail.tsx:1360
#: src/routes/Usage.tsx:122
msgid "Turns"
msgstr "Tours"

#. placeholder {0}: [...duplicateIds].join(", ")
#: src/routes/NewConfig.tsx:273
msgid "Two companies share the same id: {0}"
msgstr "Deux sociétés partagent le même id : {0}"

#: src/routes/Releases.tsx:122
#: src/routes/SystemPrompts.tsx:107
msgid "Unarchive"
msgstr "Désarchiver"

#. placeholder {0}: p.label
#: src/routes/SystemPrompts.tsx:61
msgid "Unarchive prompt \"{0}\"?"
msgstr "Désarchiver le prompt « {0} » ?"

#. placeholder {0}: v.version
#. placeholder {1}: v.channel
#: src/routes/Releases.tsx:70
msgid "Unarchive version {0} on {1}?"
msgstr "Désarchiver la version {0} sur le canal {1} ?"

#: src/components/RequestPricing.tsx:16
msgid "Unavailable"
msgstr "Indisponible"

#: src/routes/CustomerDetail.tsx:458
msgid "Unpause (paid)"
msgstr "Reprendre (payé)"

#. placeholder {0}: customer.name
#: src/routes/CustomerDetail.tsx:368
msgid "Unpause {0}? Access resumes at the next agent request."
msgstr "Reprendre {0} ? L'accès est rétabli à la prochaine requête d'agent."

#: src/routes/ConversationDetail.tsx:191
#: src/routes/Conversations.tsx:474
msgid "Updated"
msgstr "Modifiée"

#: src/routes/SystemPrompts.tsx:129
msgid "Updated at"
msgstr "Mis à jour le"

#: src/components/Layout.tsx:173
#: src/routes/Customers.tsx:271
#: src/routes/Usage.tsx:119
msgid "Usage"
msgstr "Consommation"

#: src/routes/Usage.tsx:58
msgid "Usage & cost"
msgstr "Consommation et coût"

#. placeholder {0}: usage.month
#: src/routes/CustomerDetail.tsx:622
#: src/routes/CustomerDetail.tsx:1341
msgid "Usage this month ({0})"
msgstr "Consommation ce mois-ci ({0})"

#: src/routes/NewConfig.tsx:383
msgid "Use the id generated from the display name"
msgstr "Utiliser l’id généré à partir du nom affiché"

#: src/routes/Plans.tsx:318
msgid "Used only to name a new conversation, once per conversation. Pick the cheapest active model — the task needs no tools and no reasoning."
msgstr "Sert uniquement à nommer une nouvelle conversation, une fois par conversation. Choisir le modèle actif le moins cher — la tâche ne demande ni outils ni raisonnement."

#: src/routes/Conversations.tsx:365
msgid "User feedback"
msgstr "Retour utilisateur"

#: src/features-catalog.ts:150
msgid "User Portal"
msgstr "Portail utilisateur"

#: src/routes/NewConfig.tsx:495
msgid "Username"
msgstr "Nom d'utilisateur"

#: src/components/Layout.tsx:198
msgid "Users"
msgstr "Utilisateurs"

#: src/routes/AuditLog.tsx:80
#: src/routes/LicenseSwaps.tsx:69
#: src/routes/LicenseSwaps.tsx:80
msgid "uuid"
msgstr "uuid"

#: src/routes/Releases.tsx:144
msgid "Version"
msgstr "Version"

#: src/routes/Releases.tsx:288
msgid "Version (semver, e.g. 0.2.0)"
msgstr "Version (semver, ex. 0.2.0)"

#: src/routes/Monitoring.tsx:243
msgid "View all →"
msgstr "Voir tout →"

#: src/routes/Usage.tsx:262
msgid "View conversation"
msgstr "Voir la conversation"

#: src/routes/CustomerDetail.tsx:573
msgid "View features"
msgstr "Voir les fonctionnalités"

#: src/components/FeatureSelector.tsx:141
#: src/features-catalog.ts:163
msgid "Web API post"
msgstr "Report Web API"

#: src/components/FeatureSelector.tsx:139
#: src/features-catalog.ts:161
msgid "Web API read"
msgstr "Lecture Web API"

#: src/components/FeatureSelector.tsx:140
#: src/features-catalog.ts:162
msgid "Web API write"
msgstr "Écriture Web API"

#: src/routes/ConversationDetail.tsx:394
msgid "What happened, and what did we tell the customer?"
msgstr "Que s'est-il passé, et qu'avons-nous dit au client ?"

#: src/routes/Releases.tsx:347
msgid "What's new in this release"
msgstr "Nouveautés de cette version"

#: src/routes/Errors.tsx:382
#: src/routes/Monitoring.tsx:200
#: src/routes/Monitoring.tsx:252
msgid "When"
msgstr "Quand"

#: src/routes/AuditLog.tsx:101
#: src/routes/LicenseSwaps.tsx:129
msgid "When (UTC)"
msgstr "Quand (UTC)"

#: src/routes/Conversations.tsx:66
msgid "With failures"
msgstr "Avec échecs"

#: src/credit-reason-labels.ts:13
#: src/feedback-labels.ts:13
msgid "Wrong answer"
msgstr "Réponse erronée"

#: src/routes/Releases.tsx:95
msgid "yes"
msgstr "oui"
